<template>
  <el-dialog
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :before-close="cancel"
    :modal="false"
    :width="isDE ? '800px' : '600px'"
    style="opacity: 0.9"
    :title="$t('langcfg.txtElevPropSettings')"
    id="elev"
  >
    <el-row class="fontColor fontSize" :gutter="50">
      <el-col :span="9" style="text-align: left; padding-left: 20px; padding-right: 0px">
        <el-radio-group
          v-model="elevParams.sphereElli"
          @change="shapeChanged"
          class="radioBorder"
          :style="`text-align: left; padding-left: 10px; ${isIT ? 'width: 200px;' : ''}`"
        >
          <el-radio
            class="fontColor marBottom10"
            v-for="item in shaps"
            :key="item.label"
            :label="item.label"
            >{{ item.value }}</el-radio
          >
          <br />
        </el-radio-group>
        <el-radio-group
          v-model="elevParams.isAuto"
          @change="autoChanged"
          class="radioBorder marTop10"
          :style="`text-align: left; padding-left: 10px; ${isIT ? 'width: 200px;' : ''}`"
        >
          <el-radio
            style="font-size: 20px"
            class="fontColor marBottom10"
            v-for="item in autoManual"
            :key="item.label"
            :label="item.label"
            >{{ item.value }}</el-radio
          >
          <br />
        </el-radio-group>
        <el-checkbox
          class="fontColor marTop20 fontSize"
          style="margin-left: 10px"
          v-model="elevParams.isFloat"
          @change="floatChanged"
          >{{ $t("langcfg.txtFloat") }}</el-checkbox
        >
        <div style="line-height: 30px; padding-top: 20px; padding-left: 10px">
          RMS={{ elevParams.values.rms._toFixed(2) }}
        </div>
      </el-col>
      <el-col :span="15">
        <el-row v-for="(item, id) in elevShown" :key="item.label" class="inputNum">
          <el-col :span="10" style="margin-top: 20px">{{ item.label }}</el-col>
          <el-col :span="14">
            <el-input-number
              style="width: 100%"
              :data-name="id"
              :data-disbled="item.disabled"
              :ref="`input${id}`"
              :step="0.05"
              :precision="2"
              :min="item.min"
              :max="item.max"
              :disabled="item.disabled"
              v-model="elevParams.values[id]"
              @change="paramChanged(id, arguments[0], arguments[1])"
            ></el-input-number>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row slot="footer">
      <el-button style="font-size: 30px" class="btn-oprator border-normal" @click="save">
        <span>{{ $t("langcfg.txtOK") }}</span>
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import EVENTS from "../../bus";
import { canConvertNumber, isNumber } from "../../shared/utils";
import Cal from "../js/CalElev";
export default {
  name: "ElevPropsSettings",
  props: {
    show: Boolean,
    parentForm: {
      type: String,
      default: ""
    },
    indexInForm: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      shaps: [
        { value: this.$t("langcfg.txtEllipsoid"), label: 1 },
        { value: this.$t("langcfg.txtSphere"), label: 0 }
      ],
      autoManual: [
        { value: this.$t("langcfg.txtAutoSelect"), label: 0 },
        { value: this.$t("langcfg.txtManualSelect"), label: 1 }
      ],
      num: 1,
      elevParams: {},
      isDE: false,
      isIT: false
    };
  },
  created() {
    if (this.parentForm === "compare2records") {
      if (this.indexInForm === 0) {
        this.elevParams = global.elevParamsDiff0;
      } else {
        this.elevParams = global.elevParamsDiff1;
      }
    } else {
      this.elevParams = global.elevParams;
    }
  },
  mounted() {
    this.$nextTick(() => {
      let self = this;
      for (let id in this.elevShown) {
        let key = self.$refs[`input${id}`][0].$attrs["data-name"];
        self.$refs[`input${key}`][0].$children[0].$el.addEventListener("touchend", (e) => {
          let disabled = e.target.disabled;
          if (disabled) return;
          e.preventDefault();
          e.stopPropagation();

          let key = e.target.parentNode.parentNode.getAttribute("data-name");

          self.$bus.$emit(EVENTS.spreadKeyBoard, self.elevParams.values[key], (value) => {
            if (canConvertNumber(value)) {
              self.elevParams.values[key] = parseFloat(value);
            }
          });
        });
        self.$refs[`input${key}`][0].$children[0].$el.addEventListener("click", (e) => {
          let disabled = e.target.disabled;
          if (disabled) return;
          e.preventDefault();
          e.stopPropagation();

          let key = e.target.parentNode.parentNode.getAttribute("data-name");

          self.$bus.$emit(EVENTS.spreadKeyBoard, self.elevParams.values[key], (value) => {
            if (canConvertNumber(value)) {
              self.elevParams.values[key] = parseFloat(value);
            }
          });
        });
      }
    });
    this.isDE = window.settings.language === "de";
    this.isIT = window.settings.language === "it";
  },
  updated() {
    this.isDE = window.settings.language === "de";
    this.isIT = window.settings.language === "it";
  },
  methods: {
    recalElevParams() {
      Cal.cal(this.elevParams, this.$store.state.topography.casePath);
      this.$emit("updateMap", this.elevParams.data);
    },
    save() {
      this.$emit("close");
      this.showDialog = false;
    },
    cancel() {
      this.$emit("close");
      this.showDialog = false;
    },
    floatChanged() {
      if (this.elevParams.isFloat) {
        this.elevParams.values.shiftX = this.elevParams.values.shiftY = 0;
      }
      this.elevParams.hadInitial = false;
      this.recalElevParams();
    },
    shapeChanged() {
      this.elevParams.hadInitial = false;
      this.recalElevParams();
    },
    autoChanged() {
      if (this.elevParams.isAuto === 1) {
        this.elevParams.values.dia = 8;
      }
      this.elevParams.hadInitial = false;
      this.recalElevParams();
    },
    paramChanged(id, curVal, oldVal) {
      if (id === "rs") {
        this.elevParams.values.rf = curVal;
      }
      if (id === "dia") {
        this.elevParams.hadInitial = false;
      }
      this.recalElevParams();
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    },
    elevShown: {
      get: function () {
        return {
          rf: {
            label: "Rf:",
            min: 2,
            max: 15,
            disabled: true
          },
          rs: {
            label: "Rs:",
            min: 2,
            max: 15,
            disabled: false
          },
          ecc: {
            label: "ecc:",
            min: -1,
            max: 2,
            disabled: this.elevParams.sphereElli === 0
          },
          dia: {
            label: this.$t("langcfg.txtDia") + ":",
            min: 1,
            max: 13,
            disabled: this.elevParams.isAuto === 0
          },
          shiftX: {
            label: "ShiftX:",
            min: -1000,
            max: 1000,
            disabled: this.elevParams.isFloat
          },
          shiftY: {
            label: "ShiftY:",
            min: -1000,
            max: 1000,
            disabled: this.elevParams.isFloat
          }
        };
      }
    }
  }
};
</script>

<style lang="less">
#elev {
  .el-radio__label {
    font-size: 30px;
    color: white;
    vertical-align: middle;
  }
  .el-radio__inner {
    width: 30px;
    height: 30px;
  }
  .el-tabs__item {
    font-size: 30px;
    color: white;
    margin-bottom: 5px;
  }
  .el-checkbox .el-checkbox__label {
    font-size: 30px;
  }
  .el-checkbox__inner {
    width: 30px;
    height: 30px;
  }
  .el-checkbox__inner::after {
    width: 12px;
    height: 25px;
    left: 8px;
    top: -5px;
  }
  .el-button:focus,
  .el-button:hover {
    .label {
      color: @btn-hover-color;
    }
  }
  .el-button {
    height: @header-fs+25px;
  }
  .el-button:hover {
    span {
      color: @btn-hover-color;
    }
  }
}

.fontColor {
  color: white;
}
.fontSize {
  font-size: 30px;
}
.radioBorder {
  border: 1px solid grey;
  padding-top: 10px;
}
.inputNum {
  text-align: left;
  margin-bottom: 10px;
  vertical-align: middle;
}
.marTop10 {
  margin-top: 10px;
}
.marBottom10 {
  margin-bottom: 10px;
}
.marTop20 {
  margin-top: 20px;
}
.padTop10 {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ElevPropsSettings.vue